var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 210",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 118,
    fontFamily: "Raleway, Arial, sans-serif",
    fontSize: 110,
    fontWeight: 800,
    fill: "black",
    letterSpacing: -2
  }, "THESIS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 180,
    fontFamily: "Raleway, Arial, sans-serif",
    fontSize: 56,
    fontWeight: 600,
    fill: "black"
  }, ".center")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogo);
export default __webpack_public_path__ + "static/media/textLogo.79379da51c1938669edf95402cd09142.svg";
export { ForwardRef as ReactComponent };